import React from 'react';
import { Link } from 'react-router';

export type TextLinkProps = {
  to: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'light';
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  external?: boolean;
};

export function TextLink(props: TextLinkProps) {
  const { to, children, variant = 'primary', className, onClick, external } = props;

  // We'll base our styling on the variant
  // For example, "primary" is pastel pink, "secondary" might be pastel blue
  const baseStyles = `
    font-semibold text-dark
    transition
    ${className || ''}
  `;
  const variantStyles =
    variant === 'primary'
      ? 'hover:text-primary' // e.g., pink -> peach on hover
      : variant === 'secondary'
      ? 'hover:text-secondary'
      : 'hover:text-light';

  return (
    <Link
      to={to}
      className={`${baseStyles} ${variantStyles}`}
      onClick={onClick}
      target={external ? '_blank' : undefined}
    >
      {children}
    </Link>
  );
}
